import { InteractionType } from "@edgetier/watchtower-types";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
    faClipboard,
    faComment,
    faCommentLines,
    faEnvelope,
    faPhone,
    faShareNodes,
} from "@fortawesome/pro-solid-svg-icons";

export const InteractionIcons: Record<InteractionType, IconDefinition> = {
    [InteractionType.Call]: faPhone,
    [InteractionType.Chat]: faComment,
    [InteractionType.Email]: faEnvelope,
    [InteractionType.Messaging]: faCommentLines,
    [InteractionType.SocialMedia]: faShareNodes,
    [InteractionType.SocialMediaAlternative]: faShareNodes,
    [InteractionType.Survey]: faClipboard,
};
export const InteractionColors: Record<InteractionType, string> = {
    [InteractionType.Call]: "violet",
    [InteractionType.Chat]: "primary",
    [InteractionType.Email]: "success",
    [InteractionType.Messaging]: "error",
    [InteractionType.SocialMedia]: "warning",
    [InteractionType.SocialMediaAlternative]: "warning",
    [InteractionType.Survey]: "cyan",
};
